module cr.entity {
    class NodeBase implements ITreeNode {

        TreeManager:entity.ITreeManager;
        id:string;
        collapsed:boolean;
        _displayName:string;
        displayName()
        {
            return this._displayName;
        }

        nodeType=()=>"";

        parent:entity.ITreeNode;
        nodes:Array<entity.ITreeNode>;

        Action(actionName:string, args?:any) {
            this.parent.nodes = this.parent.nodes.filter(obj=>obj.id != this.id);
        }

        constructor(displayName:string, id:string, parentNode?:ITreeNode) {
            this._displayName = displayName;
            this.id = id;
            this.parent = parentNode;
        }
    }
}